import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';
import { Helmet } from 'react-helmet'; // Importing React Helmet

// All pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import DemoProduct from './pages/DemoProduct';

import { useDocTitle } from './components/CustomHook';
import ScrollToTop from './components/ScrollToTop';
import About from './components/About/about';
import ServicePage from './components/Service/Service';
import Career from './components/Career';
import { BlogPageOne } from './components/Blog';

function App() {
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    };

    window.addEventListener('load', () => {
      aos_init();
    });
  }, []);

  // Remove useDocTitle and manage it with React Helmet
  // useDocTitle(" Astric Technology ");

  return (
    <>
      <Helmet>
        <title>Astric Technology - Where Technology Meets Innovation</title>
        <meta name="description" content="Astric Technology offers end-to-end software services for startups, including web and mobile app development." />
        <meta name="keywords"
          content="tech company in United Arab Emirates,top tech company in United Arab Emirates,top 10 tech company in United Arab Emirates,best tech company in United Arab Emirates, digital company in United Arab Emirates, best IT company in United Arab Emirates, software development in United Arab Emirates, e-commerce solutions United Arab Emirates, fantasy sports tech company, top tech company in Dubai, web development in United Arab Emirates, mobile app development in United Arab Emirates, startup tech company in United Arab Emirates, custom software services United Arab Emirates, Astric Technologies, digital transformation services, IT solutions in United Arab Emirates, marketing solutions United Arab Emirates" />
          <link rel="canonical" href="https://www.astrictechnology.com" />
        {/* Add any additional meta tags you need */}
      </Helmet>

      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<ServicePage />} />
            <Route path="/careers" element={<Career />} />
            <Route path="/blogs" element={<BlogPageOne />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/get-demo" element={<DemoProduct />} />
            {/* Redirect to home page for all undefined routes */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </>
  );
}

export default App;
